import { Flex, Text, theme } from '@/components';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { AnalysisDrillThroughDropdown } from './analysis-table/AnalysisDrillThroughDropdown';

export const AnalysisResultsError: FC<{ errorMessage: string }> = ({
  errorMessage,
}) => {
  const { token } = theme.useToken();
  const { t } = useTranslation();

  return (
    <Flex vertical>
      <Flex
        style={{
          backgroundColor: token.colorBgLayout,
          height: 300,
          margin: 16,
        }}
        justify="center"
        align="center"
      >
        <Text text={errorMessage} />
      </Flex>
      <Flex justify="flex-end">
        <AnalysisDrillThroughDropdown
          disabled
          fallbackText={t('drill-through-no-applicable-year')}
        />
      </Flex>
    </Flex>
  );
};
